"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorScreen = void 0;
//@ts-ignore
const services_1 = require("@qsite/services");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importDefault(require("styled-components"));
const __1 = require("../");
const Oops = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	width: 40%;
	margin: 10vh auto;

	@media only screen and (max-width: 1000px) {
		width: 60%;
	}

	@media only screen and (max-width: 700px) {
		width: 80%;
	}

	.try-again-container {
		margin: 1rem auto;
		font-size: 1rem;
		font-weight: ${({ theme }) => `${theme.fontSemibold}`};
		text-align: center;

		a {
			text-decoration: none;
			color: ${({ theme }) => theme != null ? theme.denimBlue : theme.pacificBlue};
		}
	}

	.error-tooltip {
		background-color: ${({ theme }) => `${theme.lightRed}`};
		padding: 15px 20px 15px 20px;
		margin-top: 30px;
		font-size: ${({ theme }) => `${theme.smallFontSize}`};
		color: ${({ theme }) => theme != null ? theme.invalidRed : theme.textBlack};
		border-radius: 4px;
	}
`;
const ErrorScreen = ({ pageToRedirect, tryAgain, translatedKeys }) => {
    const [state, dispatch] = services_1.useStore();
    const { error: errorSettings } = state.qsiteSettings;
    const error = state.appSettings.error.errorResponse.data.data;
    const { resetQsiteInitialState } = services_1.useReset();
    const i18n = react_i18next_1.useTranslation();
    const resetError = (e) => {
        e.preventDefault();
        resetQsiteInitialState();
        dispatch(services_1.appSettingsActions.setError({ showErrorScreen: false, errorResponse: null }));
    };
    react_1.useEffect(() => {
        const elements = document.getElementsByTagName('h1');
        if (elements.length > 0)
            elements[0].focus();
    }, []);
    react_1.useEffect(() => {
        return () => {
            dispatch(services_1.appSettingsActions.setProgress({ path: pageToRedirect, method: __1.NAVIGATION_ACTION.REPLACE }));
        };
    }, [dispatch]);
    return (react_1.default.createElement(Oops, null,
        react_1.default.createElement(__1.Title, { title: errorSettings.title, subtitle: errorSettings.description || '' }),
        !!tryAgain && translatedKeys.tryAgainMessage != null &&
            react_1.default.createElement("div", { className: 'try-again-container' },
                react_1.default.createElement(react_i18next_1.Trans, { i18nKey: translatedKeys.tryAgainMessage },
                    "Or ",
                    react_1.default.createElement("a", { href: pageToRedirect, onClick: resetError }, "click here"),
                    " to try again")),
        error != null &&
            react_1.default.createElement("div", { className: 'error-tooltip' },
                react_1.default.createElement("p", null,
                    translatedKeys.errorCode,
                    " ",
                    error.errorCode),
                react_1.default.createElement("p", null,
                    translatedKeys.errorMessage,
                    " ",
                    error.message),
                react_1.default.createElement("p", null,
                    translatedKeys.errorRef,
                    " ",
                    error.ref))));
};
exports.ErrorScreen = ErrorScreen;
